require('es6-promise').polyfill();
window._ = require( 'lodash' );
window.Popper = require( 'popper.js' ).default;
window.$ = window.jQuery = require( 'jquery' );
import 'jquery-ui/ui/widgets/datepicker.js';

var Promise = require('es6-promise').Promise; // promise polyfill

if ('NodeList' in window && !NodeList.prototype.forEach) {
	// forEach polyfill
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

$.datepicker.regional[ 'ko' ] = {
	closeText : '닫기',
	prevText : '이전달',
	nextText : '다음달',
	currentText : '오늘',
	monthNames : ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
	monthNamesShort : ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
	dayNames : ['일', '월', '화', '수', '목', '금', '토'],
	dayNamesShort : ['일', '월', '화', '수', '목', '금', '토'],
	dayNamesMin : ['일', '월', '화', '수', '목', '금', '토'],
	weekHeader : 'Wk',
	dateFormat : 'yy-mm-dd',
	firstDay : 0,
	isRTL : false,
	showMonthAfterYear : true,
	yearSuffix : '년'
};
$.datepicker.setDefaults($.datepicker.regional['ko']);

$( '.datetimepicker' ).datepicker( {
	format: 'YYYY-MM-DD'
} );

try {
	require( 'bootstrap' );
	require( 'jquery-datepicker' );
	window.feather = require( 'feather-icons' );
	feather.replace();

	window.axios = require( 'axios' );
	window.Mark = require('mark.js/dist/mark');

	const Webfont = require( 'webfontloader' );
	Webfont.load( {
		              google: {
			              families: [ 'Gothic A1:400,700&amp;subset=korean', 'Heebo:400,400i,700,700i' ]
		              },
		              timeout: 2000
	              } );

}
catch ( e ) {
	alert( '컴파일 오류 : ' + e.message );
	console.log( e );
}

window.axios.defaults.headers.common[ 'X-Requested-With' ] = 'XMLHttpRequest';
let token = document.head.querySelector( 'meta[name="csrf-token"]' );

if ( token ) {
	window.axios.defaults.headers.common[ 'X-CSRF-TOKEN' ] = token.content;
}
else {
	console.error( 'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token' );
}

const apiToken = document.head.querySelector('meta[name="api-token"]');
if ( apiToken && apiToken.content !== '' ) {
	window.axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken.content}`;
}


$( '#aside-toggler' ).click( function () {
	let sidemenu = document.getElementById( 'aside' ).getBoundingClientRect();
	if ( sidemenu.left < 0 ) {
		$( 'aside' ).css( 'left', 0 );
	}
	else {
		$( 'aside' ).css( 'left', '-100vw' );
	}
} );

const checkAll = document.getElementById('checkAll');
if ( checkAll ) {
	checkAll.addEventListener('click', e=>{
		const items = document.querySelectorAll('input[name="id[]"]');
		if ( items && items.length > 0 ) {
			items.forEach(el=>{
				el.checked = checkAll.checked;
			})
		}
	})
}

window.nullCheck = obj => obj === null ? '' : obj;

let Clipboard = require( 'clipboard' );

new Clipboard( '.btn-copy' ).on( 'success', function ( e ) {
	let copyBtn = $( e.trigger ).find( '.feather' );
	if ( copyBtn.length > 0 ) {
		copyBtn.hide();
		copyBtn.parents( 'td' ).append( '<span class="copy-info">복사됨</span>' );
		setTimeout( function () {
			copyBtn.parents( 'td' ).find( '.copy-info' ).remove();
			copyBtn.show();
		}, 1000 )
	}
	else {
		$( e.trigger ).append( '<span class="copy-info text-success">Copied!</span>' );
		setTimeout( function () {
			$( e.trigger ).find( '.copy-info' ).fadeOut( 200 );
		}, 1000 )
	}

	e.clearSelection();
} );

$('[data-toggle="tooltip"]').tooltip();